import { useEffect } from 'react';
import { signOut } from 'utils/auth';
import withDismount from 'hocs/withDismount';

const Signout = () => {
  const handleSignout = async () => {
    await signOut();
    window.location.href = '/';
  };

  useEffect(() => {
    handleSignout();
  }, []);
  return (
    <div>Signing out...</div>
  );
};

export default withDismount(Signout);
